export default "__VITE_ASSET__BsREyrzS__";